import React from 'react';
import { styled } from 'styled-components';
const Success = (props) => {
    return (React.createElement(SuccessStyled, null, props.messages.map((m) => (React.createElement("div", { className: "success" }, m)))));
};
export default Success;
const SuccessStyled = styled.div `
  .success {
    border-radius: 3px;
    background-color: #28a745;
    padding: 12px 15px;
    font-size: 0.8em;
    margin-bottom: 20px;
    width: 100%;
    background-image: none;
    border: 1px solid #28a745;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    color: white;
  }
`;
//# sourceMappingURL=Success.js.map